<template>
  <patient-profile>
    <div class="invoice-list-invoices__section">
      <patient-paid-stats
        v-if="isShowPatientPayments"
        v-bind:advance="patientPayments.advance"
        v-bind:debt="patientPayments.debt"
        v-bind:is-await-force-recharge="isAwaitForceRecharge"
        v-bind:is-await-recharge="isAwaitCommandExecuted"
        v-bind:is-await-act-request="isAwaitActRequest"
        v-bind:paid="patientPayments.paid"
        v-bind:patient-loyalty-card="patientLoyaltyCard"
        v-bind:can-force-recharge="canForceRecharge"
        v-on:open-recharge-form="onOpenAdvanceRechargeForm"
        v-on:withdrawal-open="onOpenAdvanceWithdrawalForm"
        v-on:force-recharge="onForceAdvanceRecharge"
        v-on:print-act="onPrintAct"
        v-on:download-act="onDownloadAct"
        v-on:open-modal-create-bonus-card="onOpenCreateBonusCardModal"
        v-on:open-modal-create-discount-card="onOpenCreateDiscountCardModal"
        v-on:open-detail-bonus-card-sidebar="onOpenDetailedBonusCard"
        v-on:open-detail-discount-card-sidebar="onOpenDetailedDiscountCard"
      />
      <div class="invoice-list__filters">
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByAllStatus"
          v-bind:value="$options.filterByAllStatus"
          v-model="filterByStatus"
        />
        <label
          class="invoice-list__filters__item"
          v-bind:for="$options.filterByAllStatus"
        >
          Все
        </label>
        <input
          v-bind:id="$options.filterByPayedStatus"
          hidden
          type="radio"
          v-bind:value="$options.filterByPayedStatus"
          v-model="filterByStatus"
        />
        <label
          class="invoice-list__filters__item invoice-list__icon payed"
          v-bind:for="$options.filterByPayedStatus"
        >
          Оплачено
        </label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByPartiallyPayedStatus"
          v-bind:value="$options.filterByPartiallyPayedStatus"
          v-model="filterByStatus"
        />
        <label
          class="invoice-list__filters__item invoice-list__icon partially_payed"
          v-bind:for="$options.filterByPartiallyPayedStatus"
        >
          Частично оплачено
        </label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByWaitStatus"
          v-bind:value="$options.filterByWaitStatus"
          v-model="filterByStatus"
        />
        <label
          class="invoice-list__filters__item invoice-list__icon wait"
          v-bind:for="$options.filterByWaitStatus"
        >
          Ожидает оплаты
        </label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByInProcessStatus"
          v-bind:value="$options.filterByInProcessStatus"
          v-model="filterByStatus"
        />
      </div>
      <table v-if="!isEmpty" class="invoice-list__table" :class="{ 'empty-table': isEmpty }">
        <thead class="invoice-list__table__head" :class="{ 'is-filial': hasBranchSystem }">
          <tr>
            <template v-for="{ actions, id, name } in visibleColumns">
              <template v-if="actions.includes('sort')">
                <th v-bind:key="id" class="invoice-list__table__cell date">
                  <input-sort
                    v-model="sortByDate"
                    v-on:input="onSortByDate"
                    desc-first
                    name="date"
                  >
                    <div
                      class="invoice-list__table__cell__sort"
                      v-bind:class="{ selected: sortByDate ? 'selected' : '' }"
                    >
                      {{ name }}
                    </div>
                  </input-sort>
                </th>
              </template>
              <th
                v-else
                v-bind:key="id"
                :data-inv="id"
                class="invoice-list__table__cell id"
                v-bind:class="id">
                {{ name }}
              </th>
            </template>
            <th class="invoice-list__table__cell settings">

              <popover-menu>
                <template v-slot:trigger="{ listenerObject }">
                  <button
                    v-on="listenerObject"
                    class="invoice-list__icon-settings"
                    type="button"
                  />
                </template>
                <form-table-settings
                  v-bind:columns="tableColumnSettings"
                  v-on:change="onChangeColumnSettings"
                />
              </popover-menu>
            </th>
          </tr>
        </thead>
        <tbody class="invoice-list__table__body">
          <router-link
            v-for="(invoice, key) in invoiceList"
            v-bind:key="key"
            class="invoice-list__table__row"
            v-bind:class="{ 'is-filial': hasBranchSystem }"
            v-bind:to="getNavigation(invoice.id)"
          >
            <template v-for="{ fieldKey, name } in visibleColumns">
              <td
                v-if="fieldKey === 'createdAt'"
                v-bind:key="fieldKey"
                class="invoice-list__table__cell date"
                v-bind:data-label="name"
              >
                {{ invoice[fieldKey] }}
              </td>
              <td
                v-else-if="fieldKey === 'status'"
                v-bind:key="fieldKey"
                class="invoice-list__table__cell"
                v-bind:class="invoice.statusId.toLowerCase()"
                v-bind:data-label="name"
              >
                <span
                  class="invoice-list__icon"
                  v-bind:class="invoice.statusId.toLowerCase()"
                >
                  {{ invoice[fieldKey] }}
                </span>
              </td>
              <td
                v-else-if="fieldKey === 'comment'"
                v-bind:key="fieldKey"
                class="invoice-list__table__cell comment"
                v-bind:data-label="name"
              >
                <button
                  type="button"
                  v-if="invoice.comment !== ''"
                  v-on:click.prevent.stop="onViewInvoiceComment(invoice.comment)"
                >
                  <img src="@/assets/img/eye-open.svg" alt="Комментарий" />
                </button>
              </td>
              <td
                v-else
                v-bind:key="fieldKey"
                class="invoice-list__table__cell"
                v-bind:class="fieldKey"
                v-bind:data-label="name">{{ invoice[fieldKey] }}
              </td>
            </template>
          </router-link>
        </tbody>
      </table>
      <p v-else class="invoice-list__empty">Счетов не найдено</p>
    </div>
    <side-slide-transition>
      <side-dialog
        v-on:cancel="onCloseAdvanceRechargeForm"
        v-if="isShownAdvanceRechargeForm"
        label="Пополнение аванса"
      >
        <form-advance-recharge
          v-bind:cashbox-list="cashboxList"
          v-bind:is-await-request="isAwaitAdvanceRechargeRequest"
          v-bind:patient-id="patientId"
          v-on:cancel="onCloseAdvanceRechargeForm"
          v-on:submit="onAdvanceRechargeSubmit"
        />
      </side-dialog>
    </side-slide-transition>
    <open-shift-modal-dialog
      v-bind:is-await-request="isAwaitShiftRequest"
      v-model="isShowShiftOpenDialog"
      v-on:submit="onOpenShift"
    />
    <modal-dialog
      title="Комментарий счёта"
      v-bind:value="isShowInvoiceCommentModal"
      v-on:input="onCloseInvoiceCommentModal"
      v-on:on-click-outside="onCloseInvoiceCommentModal"
      with-cross
    >
      <invoice-comment
        v-bind:comment="selectedInvoiceComment"
      />
    </modal-dialog>
    <iframe
      class="invoice-list__print"
      ref="printView"
      title="printView"
    />
    <modal-dialog-bonus-card
      v-model="isShowCreateBonusCardModal"
      v-on:on-click-outside="onCloseCreateBonusCardModal"
    >
      <form-create-bonus-card
        v-bind:violations="inputErrors"
        v-model="patientLoyaltyCard"
        v-on:submit="onSubmitBonusCard"
      />
    </modal-dialog-bonus-card>
    <modal-dialog-bonus-card
      v-model="isShowCreateDiscountCardModal"
      v-on:on-click-outside="onCloseCreateDiscountCardModal"
    >
      <form-create-discount-card
        v-model="patientLoyaltyCard"
        v-bind:violations="inputErrors"
        v-on:submit="onSubmitDiscountCard"
      />
    </modal-dialog-bonus-card>
    <confirm-side-dialog
      v-if="hasAdvanceForWithdrawal"
      label="Списание аванса"
      v-on:cancel="onCloseAdvanceWithdrawalForm"
    >
      <form-advance-withdrawal
        class="form-advance-withdrawal-dialog__body"
        v-bind:cashbox-list="cashboxListForWithdrawal"
        v-bind:is-await-request="isAwaitAdvanceWithdrawalRequest"
        v-on:submit="onAdvanceWithdrawalSubmit"
      />
    </confirm-side-dialog>
    <confirm-side-dialog
      v-if="isShowDetailedBonusCard"
      v-bind:label="detailedBonusCard.getBonusCardName()"
      v-on:cancel="onCloseDetailedBonusCard"
    >
      <bonus-card-info v-bind:detail-bonus-card="detailedBonusCard" />
    </confirm-side-dialog>
    <confirm-side-dialog
      v-if="isShowDetailedDiscountCard"
      v-bind:label="detailedDiscountCard.getDiscountCardName()"
      v-on:cancel="onCloseDetailedDiscountCard"
    >
      <detail-discount-card-info v-bind:detail-discount-card="detailedDiscountCard" />
    </confirm-side-dialog>
  </patient-profile>
</template>

<script>
import advanceRechargeMixin from '@/mixins/advanceRechargeMixin';
import notifierMixin from '@/mixins/notifierMixin';
import shiftMixin from '@/mixins/shiftMixin';
import { List, Maybe } from 'monet';
import ModalDialog from '@/components/ModalDialog.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import SideDialog from '@/components/SideDialog.vue';
import FormAdvanceRecharge from '@/components/FormAdvanceRecharge.vue';
import FormAdvanceWithdrawal from '@/components/FormAdvanceWithdrawal.vue';
import onlineCheckMixin from '@/mixins/onlineCheckMixin';
import OpenShiftModalDialog from '@/components/OpenShiftModalDialog.vue';
import PatientPaidStats from '@/components/PatientPaidStats.vue';
import advanceWithdrawMixin from '@/mixins/advanceWithdrawMixin';
import InvoiceComment from '@/components/InvoiceComment.vue';
import InputSort from '@/components/InputSort.vue';
import {
  GOAL_FILTERS_PATIENT_INVOICE,
  GOAL_TOP_UP_ADVANCE_PATIENT_INVOICES,
  GOAL_WRITE_OFF_ADVANCE_PATIENT_INVOICES,
} from '@/plugins/metric';
import metricMixin from '@/mixins/metricMixin';
import loyaltySystemMixin from '@/mixins/loyaltySystemMixin';
import FormCreateBonusCard from '@/components/FormCreateBonusCard.vue';
import ModalDialogBonusCard from '@/components/ModalDialogBonusCard.vue';
import DetailedBonusCardInfo from '@/components/DetailedBonusCardInfo.vue';
import DetailDiscountCardInfo from '@/components/DetailDiscountCardInfo.vue';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import FormCreateDiscountCard from '@/components/FormCreateDiscountCard.vue';
import PopoverMenu from '@/components/PopoverMenu.vue';
import FormTableSettings from '@/components/FormTableSettings.vue';
import customizableTableMixin from '@/mixins/customizableTableMixin';
import saveFileMixin from '@/mixins/saveFileMixin';

/**
 * @description Действие проверки состояния смены.
 * @type {string}
 */
const ACTION_CHECK_SHIFT_STATE = 'check-shift-state';

/**
 * @description Действие принудительно провести оплату.
 * @type {string}
 */
const ACTION_FORCE_MAKE_PAYMENT = 'force-make-payment';

/**
 * @description Идентификатор таблицы.
 * @type {string}
 */
const TABLE_ID = 'invoices';

/**
 * @description Примесь пополнения аванса.
 * @type {object}
 */
const rechargeMixin = {
  computed: {
    /**
     * @description Разрешить принудительно провести оплату.
     * @type {boolean}
     */
    canForceRecharge() {
      if (!this.rechargeCommandId) {
        return false;
      }
      return this.actions.includes(ACTION_FORCE_MAKE_PAYMENT)
        || this.onlineCheckActions.includes(ACTION_FORCE_MAKE_PAYMENT);
    },
  },
  data() {
    return {
      /**
       * @description Ожидание выполнения принудительного проведения оплаты.
       * @type {boolean}
       */
      isAwaitForceRecharge: false,
    };
  },
  methods: {
    /**
     * @description Обработать открытие формы пополнения аванса.
     * @returns {void}
     */
    onOpenAdvanceRechargeForm() {
      if (this.needOpenedShift) {
        this
          .checkShiftIsOpened()
          .then(async (isOpened) => {
            if (isOpened) {
              this.continueOperation();
            }
          });
      } else {
        this.continueOperation();
      }
    },
    /**
     * @description Обработать отправку запроса на пополнение аванса.
     * @param {AdvanceRechargeRequest} request Запрос.
     * @returns {void}
     */
    onAdvanceRechargeSubmit(request) {
      this
        .sendAdvanceRechargeRequest(request)
        .then((isSuccess) => {
          if (isSuccess) {
            this.reloadList();
            this.reachGoalIfNotReach(GOAL_TOP_UP_ADVANCE_PATIENT_INVOICES);
          }
        });
    },
    /**
     * @description Продолжить операцию.
     * @returns {void}
     */
    continueOperation() {
      this.openAdvanceRechargeForm();
    },
    onForceAdvanceRecharge() {
      if (!this.rechargeCommandId) {
        return;
      }
      this.isAwaitForceRecharge = true;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.isAwaitForceRecharge = false;
      };
      this
        .$invoiceGateway
        .forcePayment(this.rechargeCommandId)
        .then((result) => result.forEachLeft(onFail))
        .catch(() => {
          this.isAwaitForceRecharge = false;
        });
    },
  },
  mixins: [advanceRechargeMixin, shiftMixin, metricMixin],
};

/**
 * @description Примесь списания аванса.
 * @type {object}
 */
const withdrawalMixin = {
  methods: {
    /**
     * @description Обработать открытие формы пополнения аванса.
     * @returns {void}
     */
    onOpenAdvanceWithdrawalForm() {
      if (this.needOpenedShift) {
        this
          .checkShiftIsOpened()
          .then(async (isOpened) => {
            if (isOpened) {
              this.openAdvanceWithdrawalForm();
            }
          });
      } else {
        this.openAdvanceWithdrawalForm();
      }
    },
    /**
     * @description Обработать отправку запроса на списание аванса.
     * @param {AdvanceWithdrawal} withdrawal Списание.
     * @returns {void}
     */
    onAdvanceWithdrawalSubmit(withdrawal) {
      this
        .sendAdvanceWithdrawalRequest(this.patientId, withdrawal)
        .then((isSuccess) => {
          if (isSuccess) {
            this.reloadList();
            this.reachGoalIfNotReach(GOAL_WRITE_OFF_ADVANCE_PATIENT_INVOICES);
          }
        });
    },
  },
  mixins: [advanceWithdrawMixin, metricMixin],
};

export default {
  filterByAllStatus: 'all',
  filterByPartiallyPayedStatus: 'partially_payed',
  filterByPayedStatus: 'payed',
  filterByWaitStatus: 'wait',
  components: {
    FormCreateDiscountCard,
    FormTableSettings,
    PopoverMenu,
    ConfirmSideDialog,
    BonusCardInfo: DetailedBonusCardInfo,
    DetailDiscountCardInfo,
    ModalDialogBonusCard,
    FormCreateBonusCard,
    InvoiceComment,
    InputSort,
    FormAdvanceRecharge,
    FormAdvanceWithdrawal,
    ModalDialog,
    OpenShiftModalDialog,
    PatientPaidStats,
    PatientProfile,
    SideDialog,
    SideSlideTransition,
  },
  computed: {
    /**
     * @description Имеется подключенная филиальная система.
     * @returns {boolean}
     */
    hasBranchSystem() {
      return this.$store.getters.isSectionAvailable('branch-system');
    },
    /**
     * @description Нужна открытая смена.
     * @returns {boolean}
     */
    needOpenedShift() {
      return this.actions.includes(ACTION_CHECK_SHIFT_STATE);
    },
    /**
     * @description Имеет аванс для списания.
     */
    hasAdvanceForWithdrawal() {
      return this.advanceForWithdrawal !== null;
    },
    /**
     * @description Список счетов пуст.
     * @type {boolean}
     */
    isEmpty() {
      return !this.isAwaitRequest && this.invoiceList.size() === 0;
    },
    /**
     * @description Идентификатор пациента.
     * @type {number}
     */
    patientId() {
      return +this.$route.params.id;
    },
    isShowPatientPayments() {
      return this.patient.isSome();
    },
    patientPayments() {
      return this.patient.fold({})((patient) => patient);
    },
    /**
     * @description Видимые колонки.
     * @returns {any[]}
     */
    visibleColumns() {
      return this.tableColumns.filter((candidate) => candidate.isVisible);
    },
  },
  created() {
    this.fetchTableSettings(TABLE_ID);
    this.reloadList();
    this.fetchCashboxesList();
    this.viewPatientLoyaltyCard(this.patientId);
  },
  data() {
    return {
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Показывать ли комментария счёта
       * @type boolean
       */
      isShowInvoiceCommentModal: false,
      /**
       * @description Комментарий выбранного счёта.
       * @type string
       */
      selectedInvoiceComment: '',
      /**
       * @description Действия.
       * @type {string[]}
       */
      actions: [],
      /**
       * @description Фильтровать по статусу.
       * @type {string}
       */
      filterByStatus: this.$options.filterByAllStatus,
      /**
       * @description Ожидание выполнения запроса.
       * @type {bool}
       */
      isAwaitRequest: false,
      /**
       * @description Ожидание формирования акта.
       * @type {bool}
       */
      isAwaitActRequest: false,
      /**
       * @description Список счетов пациента.
       * @type {List}
       */
      invoiceList: List(),
      /**
       * @description Пациент.
       * @type {Maybe}
       */
      patient: Maybe.none(),
      /**
       * @description Список касс.
       */
      cashboxList: [],
      sortByDate: 'desc',
    };
  },
  methods: {
    onSortByDate(sort) {
      this.sortByDate = sort;
      this.reloadList();
    },
    /**
     * @description Обработка закрытия модального окна комментария.
     * @returns {void}
     */
    onCloseInvoiceCommentModal() {
      this.isShowInvoiceCommentModal = false;
      this.selectedInvoiceComment = '';
    },
    /**
     * @description обработать показ комментария счёта.
     * @param {numeric} invoiceComment Комментарий счёта
     * @returns {void}
     */
    onViewInvoiceComment(invoiceComment) {
      this.selectedInvoiceComment = invoiceComment;
      this.isShowInvoiceCommentModal = true;
    },
    /**
     * @description Получить путь до счета.
     * @param {number} invoiceId Идентификатор счета.
     * @returns {any}
     */
    getNavigation(invoiceId) {
      const params = {
        id: this.patientId,
        invoiceId,
      };
      return {
        name: 'ClinicPanelPatientInvoice',
        params,
      };
    },
    /**
     * @description Получить список касс.
     * @returns {void}
     */
    fetchCashboxesList() {
      const onSuccess = (cashboxes) => {
        this.cashboxList = cashboxes;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$cashboxGateway
        .viewList()
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить список.
     * @returns {void}
     */
    reloadList() {
      const onSuccess = ({
        actions, invoiceList, patient, columns,
      }) => {
        this.actions = actions;
        this.invoiceList = invoiceList;
        this.patient = Maybe.some(patient);
        const { commandId } = patient;
        this.rechargeCommandId = commandId;
        this.tableColumns = columns;
        if (commandId !== null) {
          this
            .waitAdvanceRechargeCheckPrinted(commandId)
            .then((isSuccess) => {
              if (isSuccess) {
                setTimeout(this.reloadList, 2000);
              } else {
                this.isAwaitForceRecharge = false;
              }
            });
        }
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this.isAwaitRequest = true;
      const filter = this.filterByStatus
        && this.filterByStatus !== this.$options.filterByAllStatus
        ? this.filterByStatus
        : null;
      this.$invoiceGateway
        .viewList(this.patientId, filter, this.sortByDate || null)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitRequest = false;
          this.isAwaitForceRecharge = false;
        });
    },
    /**
     * @description Обработать отмену показа аванса для списания.
     * @returns {void}
     */
    onAdvanceForWithdrawalCancel() {
      this.advanceForWithdrawal = null;
    },
    /**
     * @description Обработать печать акта.
     * @param {string} dateFrom
     * @param {string} dateTo
     * @returns {void}
     */
    onPrintAct(dateFrom, dateTo) {
      this.isAwaitActRequest = true;
      const onSuccess = (response) => {
        const blob = new Blob([response], { type: 'text/html' });
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(blob));
        container.onload = () => {
          container.contentWindow.print();
        };
      };
      this
        .$patientGateway
        .formMutualSettlementsAct(this.patientId, dateFrom, dateTo)
        .then((result) => result.fold(this.notifyFail, onSuccess))
        .finally(() => { this.isAwaitActRequest = false; });
    },
    /**
     * @description Обработать скачивание акта.
     * @param {string} dateFrom
     * @param {string} dateTo
     * @returns {void}
     */
    onDownloadAct(dateFrom, dateTo) {
      this.isAwaitActRequest = true;
      const onSuccess = (response) => {
        this.saveFile(response, 'Акт взаиморасчетов.xls');
      };
      this
        .$patientGateway
        .downloadMutualSettlementsAct(this.patientId, dateFrom, dateTo)
        .then((result) => result.fold(this.notifyFail, onSuccess))
        .finally(() => { this.isAwaitActRequest = false; });
    },
    /**
     * @description Обработать изменение настроек столбцов таблицы.
     * @param {any[]}  columns
     * @returns {void}
     */
    onChangeColumnSettings(columns) {
      this.tableColumnSettings = columns;
      this.tableColumns = this.tableColumns.map((candidate) => {
        const column = columns.find(({ id }) => candidate.id === id);
        if (column) {
          return { ...candidate, isVisible: column.is_visible };
        }
        return candidate;
      });
      this.storeTableSettings(TABLE_ID);
    },
  },
  mixins: [
    notifierMixin,
    rechargeMixin,
    onlineCheckMixin,
    withdrawalMixin,
    customizableTableMixin,
    saveFileMixin,
    loyaltySystemMixin,
  ],
  name: 'ClinicPanelPatientInvoiceList',
  watch: {
    filterByStatus: {
      handler() {
        this.reachGoalIfNotReach(GOAL_FILTERS_PATIENT_INVOICE);
        this.reloadList();
      },
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";
$switch-width: 16px;

.form-advance-withdrawal-dialog {
  & &__body {
    margin-top: 1.5rem;
  }
}

.invoice-list {
  &__button {
    &-add {
      @include buttons.btn-blue(100%, 40px, 16px);
      @include buttons.btn-blue-add(16px);
      max-width: 299px;
    }
  }
  &__filters {
    margin-top: 39px;
    display: flex;
    flex-flow: row wrap;
    gap: 6px;
    &__item {
      display: flex;
      align-items: center;
      color: var(--reading-color);
      font-size: 14px;
      line-height: 17px;
      padding: 8px 15px;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        border-color: var(--action-color);
        border-width: 2px;
        padding: 7px 14px;
      }
    }
    input:checked + &__item {
      border-color: var(--action-color);
      border-width: 2px;
      padding: 7px 14px;
    }
  }
  &__empty {
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    margin: 20px 0 0 0;
  }
  &__table {
    width: 100%;
    margin: 25px 0 0 0;
    border-collapse: collapse;
    table-layout: fixed;
    overflow-x: auto;
    counter-reset: counterInvoices;
    &__head,
    &__row {
      font-size: 14px;
      text-align: left;
      vertical-align: middle;
      line-height: 17px;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
    }
    &__row {
      display: table-row;
      text-decoration: none;
      color: var(--reading-color) !important;
      text-align: left;
      border-bottom: 1px solid #eaeff3;
      &:hover {
        background: #eaeff3;
        .invoice-list__table__cell {
          background: #eaeff3;
        }
      }
    }
    &__cell {
      padding: 12px 8px;
      transition: color var(--animate-duration);
      &__sort {
        cursor: pointer;
        display: flex;
        align-items: center;
        &:after {
          content: '';
          flex-shrink: 0;
          width: 10px;
          height: 10px;
          margin: 0 0 0 5px;
          background-image: url("@/assets/img/checked/checked-grey.svg");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
        }
        &:hover {
          text-decoration: none;
        }
        &.selected {
          color: var(--action-color);
        }
      }
      &.date {
        width: 160px;
      }
      &.amount {
        white-space: nowrap;
      }
      &.comment {
        text-align: center;
      }
      &.payed,
      &.partially_payed {
        margin-inline: 0 auto;;
        background-color: #e4ffec;
      }
      &.settings {
        width: 40px;
        text-align: center;
      }
    }
  }
  &__icon {
    display: flex;
    align-items: center;
    &.payed:before {
      flex-shrink: 0;
      background-image: url("@/assets/img/checked/all-checked-green.svg");
      background-repeat: no-repeat;
      background-size: contain;
      content: "";
      height: 18px;
      margin-right: 5px;
      width: 20px;
    }
    &.partially_payed:before {
      flex-shrink: 0;
      background-image: url("@/assets/img/checked/checked-green.svg");
      background-repeat: no-repeat;
      background-size: contain;
      content: "";
      height: 15px;
      margin-right: 10px;
      width: 15px;
    }
    &.wait:before {
      background-color: #abb1a3;
      border-radius: 50%;
      content: "";
      height: 6px;
      margin-left: 4px;
      margin-right: 15px;
      width: 6px;
      flex-shrink: 0;
    }
    &-settings {
      display: inline-block;
      background-image: url("@/assets/img/settings-blue.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 18px;
      height: 18px;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
  }
  &__print {
    display: none;
  }
}

@media screen and (max-width: 1400px) {
  .invoice-list__table {
    display: block;
    &__head {
      display: none;
    }
    &__body {
      display: block;
    }
    &__row {
      display: grid;
      grid-template-columns: 1fr;
      gap: 5px;
      margin: 0 0 30px 0;
      padding: 15px 0;
      border: 1px solid #eaeff3;
    }
    & &__cell {
      display: flex;
      justify-content: space-between;
      gap: 5px 30px;
      width: auto;
      padding: 2px 8px;
      text-align: right;
      &:before {
        content: attr(data-label);
        font-weight: 700;
        text-align: left;
      }
      &.payed,
      &.partially_payed {
        margin: 0;
      }
    }
  }
}

@media screen and (max-width: 730px) {
  .invoice-list__filters__item.invoice-list__icon:before {
    display: none;
  }
}

@media screen and (max-width: 680px) {
  .invoice-list__filters {
    flex-direction: column;
    &__item.invoice-list__icon:before {
      display: flex;
    }
  }
  .invoice-list__table {
    &:not(.empty-table) {
      .invoice-list__table__row {
        width: 100% !important;
      }
    }
    &__row {
      margin: 0 0 20px 0;
      padding: 0;
      border: none;
      border-bottom: 1px solid #eaeff3;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      margin: 0;
      padding: 9px 8px;
      &__comment {
        display: flex;
        justify-content: space-between;
        margin-inline: 0;
        padding: 9px 8px;
        &:empty {
          display: none;
        }
      }
      &::before,
      &__comment:not(:empty):before {
        content: attr(data-label) !important;
        font-weight: 700;
        margin-right: 20px;
      }
    }
  }
}
</style>
